import { MaskReveal, Reveal } from "../Reveal";
import { ACTIVITY_GALLERY } from "./galleryData";

export function ActivitiesIntro() {
  const photo = ACTIVITY_GALLERY[0]!;

  return (
    <section
      className="texture-paper bg-background py-24 sm:py-28 lg:py-36"
      aria-labelledby="activities-intro-title"
    >
      <div className="mx-auto grid max-w-[1400px] gap-14 px-4 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-20 lg:px-10">
        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes="(min-width: 1024px) 45vw, 100vw"
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[4/3] w-full rounded-sm object-cover"
          />
        </MaskReveal>

        <div>
          <Reveal>
            <p className="eyebrow text-clay">More Than a Place to Stay</p>
            <h2
              id="activities-intro-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Make Your Time in Zapata Memorable
            </h2>
          </Reveal>

          <Reveal
            delay={0.08}
            className="mt-6 space-y-5 text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            <p>
              At Amigo Inn &amp; RV Park, some of the best moments happen when guests come together.
              Our property provides comfortable spaces for meals, celebrations, games,
              conversations, and relaxing after a day exploring Falcon Lake and Zapata.
            </p>
            <p>
              Whether you are organizing a family gathering, planning a fishing trip with friends,
              staying through the winter, or visiting the area for work, Amigo Inn offers
              opportunities to connect, unwind, and enjoy genuine South Texas hospitality.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
